import { render, staticRenderFns } from "./Posts2.vue?vue&type=template&id=d3ef6ef4&scoped=true"
import script from "./Posts2.vue?vue&type=script&lang=js"
export * from "./Posts2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ef6ef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3ef6ef4')) {
      api.createRecord('d3ef6ef4', component.options)
    } else {
      api.reload('d3ef6ef4', component.options)
    }
    module.hot.accept("./Posts2.vue?vue&type=template&id=d3ef6ef4&scoped=true", function () {
      api.rerender('d3ef6ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/Posts2.vue"
export default component.exports